import {
    Component,
    EventEmitter,
    Input, Output,
    ViewEncapsulation
} from '@angular/core';
import { ClientModel } from '../../../shared/models/client.model';
import { CommonHttpService } from '../../../shared/services/http.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'account-profile-basic-data',
    templateUrl: './account.profile.basic-data.component.html',
    styleUrls: [],
    encapsulation: ViewEncapsulation.None
})
export class AccountProfileBasicDataComponent {
    @Input('client') client: ClientModel;
    @Output() updated: EventEmitter<any> = new EventEmitter<any>();

    public updating = false;
    public updatingPassword = false;

    constructor(
        protected http: CommonHttpService,
        protected translate: TranslateService,
        protected toastr: ToastrService
    ) {}

    public save() {
        this.translate.get([
            'ACCOUNT.PROFILE.BOXES.BASIC_DATA.UPDATE.SUCCESS',
            'ACCOUNT.PROFILE.BOXES.BASIC_DATA.UPDATE.ERROR'
        ]).subscribe(translated => {
            this.http
                .useAuth()
                .put(`/account/clients/${this.client.id}`, {
                    name1: this.client.name1,
                    name2: this.client.name2
                })
                .subscribe(() => {
                    this.toastr.success(translated['ACCOUNT.PROFILE.BOXES.BASIC_DATA.UPDATE.SUCCESS']);
                    this.updating = false;
                }, () => {
                    this.toastr.success(translated['ACCOUNT.PROFILE.BOXES.BASIC_DATA.UPDATE.ERROR']);
                });
        });
    }

    /** Format string as CPF (natural person document) format */
    public formatNaturalPersonDocument(value: string) {
        return value.substr(0, 3) + '.'
            + value.substr(3, 3) + '.'
            + value.substr(6, 3) + '-'
            + value.substr(9, 2);
    }

    /** Format string as CPF (natural person document) format */
    public formatLegalPersonDocument(value: string) {
        return value.substr(0, 2) + '.'
            + value.substr(2, 3) + '.'
            + value.substr(5, 3) + '/'
            + value.substr(8, 4) + '-'
            + value.substr(-2);
    }

    /** Emit updated event */
    public passwordUpdated() {
        this.updatingPassword = false;
        this.updated.emit();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/account/profile/basic-data/account.profile.basic-data.component.ts